import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SITE } from '../config/site';

export default function SubscribePage() {
  const [searchParams] = useSearchParams();
  const uid = searchParams.get('uid');
  const email = searchParams.get('email');
  const initialPlan = searchParams.get('plan') === 'yearly' ? 'yearly' : 'monthly';

  const [selectedPlan, setSelectedPlan] = useState(initialPlan);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const missingData = !uid || !email;

  const handlePay = async () => {
    setError('');
    setLoading(true);

    try {
      const backendUrl =
        process.env.REACT_APP_BACKEND_URL ||
        'https://us-central1-isgerk-vaistus.cloudfunctions.net/createCheckoutSession';

      const response = await fetch(backendUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid, email, plan: selectedPlan }),
      });

      const data = await response.json();
      if (!response.ok || !data.url) {
        throw new Error(data.error || 'Nepavyko sukurti mokėjimo sesijos');
      }

      window.location.href = data.url;
    } catch (err) {
      setError(err.message || 'Įvyko klaida. Bandykite dar kartą.');
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="card">
        <h1>Išgerk vaistus</h1>
        <p>
          Aktyvuokite prenumeratą ir toliau gaukite vaistų priminimus. Mokėjimas
          prasidės iš karto. Atšaukti galite bet kada.
        </p>

        <div
          className={`plan ${selectedPlan === 'monthly' ? 'selected' : ''}`}
          onClick={() => setSelectedPlan('monthly')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && setSelectedPlan('monthly')}
        >
          <strong>{SITE.plans.subscribeMonthly}</strong>
          Mokate kas mėnesį
        </div>

        <div
          className={`plan ${selectedPlan === 'yearly' ? 'selected' : ''}`}
          onClick={() => setSelectedPlan('yearly')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && setSelectedPlan('yearly')}
        >
          <strong>{SITE.plans.subscribeYearly}</strong>
          Sutaupote lyginant su mėnesiniu
        </div>

        <div className="note">
          Mokėjimas vyksta saugiame Stripe puslapyje. Prenumeratą galite atšaukti
          bet kada – programėlė veiks iki sumokėto laikotarpio pabaigos.
        </div>

        {missingData && (
          <p className="error">
            Trūksta paskyros duomenų. Atidarykite šį puslapį iš programėlės.
          </p>
        )}

        {error && <p className="error">{error}</p>}

        <button
          type="button"
          onClick={handlePay}
          disabled={loading || missingData}
        >
          {loading ? 'Kraunama...' : 'Tęsti į mokėjimo puslapį'}
        </button>

        <p className="legal-footer">
          <a href="/privacy">Privatumo politika</a>
          {' · '}
          <a href="/terms">Naudojimo sąlygos</a>
        </p>
      </div>
    </div>
  );
}
